import { Capacitor } from '@capacitor/core';

function isNative(): boolean {
  return !!Capacitor.isNativePlatform();
}

export default isNative;
